import { render, staticRenderFns } from "./PageSEO.vue?vue&type=template&id=72e9bbbc"
import script from "./PageSEO.vue?vue&type=script&lang=js"
export * from "./PageSEO.vue?vue&type=script&lang=js"
import style0 from "./PageSEO.vue?vue&type=style&index=0&id=72e9bbbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports